// Journey manifest + resolver, renderer-free. Every journey — INCLUDING the default — is a
// lazy loader; resolving one is never synchronous. See .claude/context/journey-resolution.md.
//
// A journey is NOT a device/channel (that is the orthogonal surface resolver in
// platform/config); it is a feature-set composition for a specific use case.
export const DEFAULT_JOURNEY_ID = 'assistant';

export const journeyLoaders = {
  'paint-color-picker': () => import('./paintColorPicker/journey'),
  legacy: () => import('./legacy/journey'),
  [DEFAULT_JOURNEY_ID]: () => import('./Assistant/journey'),
};

/**
 * True if `id` names a registered journey — the default included, it is a loader like any
 * other.
 * @param {string} id
 */
export const isLazyJourney = (id) => Object.prototype.hasOwnProperty.call(journeyLoaders, id);

/**
 * Resolve an entry-point journey hint to a valid journeyId. The host page selects a
 * journey via the `magic-apron-assistant.set-journey` lifecycle event (see App);
 * this normalizes that hint — an unknown or missing hint falls back to the default
 * journey, so a bad or stale hint can never leave the shell without a journey.
 * @param {string} [hint]
 */
export const resolveJourneyId = (hint) => (isLazyJourney(hint) ? hint : DEFAULT_JOURNEY_ID);
